/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { QLogo, QuestionMarkOutlined, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { setAutoId, AutomationId } from 'utils/automationUtil'

const Container = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
`

const Watermark = styled.div`
  font-family: var(--large-font-family);
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  font-weight: ${sys.fontWeight.regular};
`

const Info = styled.div<{ mode: Theme }>`
  font-family: var(--large-font-family);
  font-size: ${sys.typescale[12].size};
  line-height: ${sys.typescale[12].lineHeight};
  font-weight: ${sys.fontWeight.regular};
  color: ${({ mode }) => sys[mode].text.placeholder};
  text-align: right;
`

const Legal = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Important = styled.div`
  font-weight: ${sys.fontWeight.semibold};
`

const Footer = () => {
  const displayTheme = useDisplayTheme()
  const { t } = useTranslation()
  return (
    <Container>
      <Watermark {...setAutoId(AutomationId.liveReport.watermark)}>
        <Link to="https://www.quid.com" target="_blank" rel="noopener noreferrer">
          <QLogo color={sys[displayTheme].text.primary} fontSize={32} />
        </Link>
        <div>{t('poweredByQuid')}</div>
      </Watermark>
      <Info mode={displayTheme}>
        <Legal {...setAutoId(AutomationId.liveReport.legalReminder)}>
          <Important>{t('importantReminder')}:</Important>{' '}
          {t('shareThisReportLinkOnlyWithAuthorizedTeamMembers')}
          <Tooltip
            mode={displayTheme}
            content={t('externalSharingOrPublicPostingViolatesOurTerms')}>
            <QuestionMarkOutlined mode={displayTheme} />
          </Tooltip>
        </Legal>
        <div {...setAutoId(AutomationId.liveReport.copyright)}>
          {t('quidCopyright', { year: new Date().getFullYear() })}
        </div>
      </Info>
    </Container>
  )
}

export default Footer
